module.exports = __webpack_public_path__ + "static/media/hall-banner.2ff212ea.png";